import { render, staticRenderFns } from "./MapObjectsSidebar.vue?vue&type=template&id=6c8f318d&scoped=true&"
import script from "./MapObjectsSidebar.vue?vue&type=script&lang=ts&setup=true&"
export * from "./MapObjectsSidebar.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./MapObjectsSidebar.vue?vue&type=style&index=0&id=6c8f318d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8f318d",
  null
  
)

export default component.exports